// removed by extract-text-webpack-plugin
module.exports = {"ParticipantsContainer":"courseCodeMemberImportModal__ParticipantsContainer__Stzio","InfoBoxContainer":"courseCodeMemberImportModal__InfoBoxContainer__2YiLX","InfoBox":"courseCodeMemberImportModal__InfoBox__2ZU4r","ModalButton":"courseCodeMemberImportModal__ModalButton__17iU0","CourseCodeSearch":"courseCodeMemberImportModal__CourseCodeSearch__3dI5A","NewParticipants":"courseCodeMemberImportModal__NewParticipants__22HPR","Search":"courseCodeMemberImportModal__Search__1czcD","Input":"courseCodeMemberImportModal__Input__Y9ai7","Icon":"courseCodeMemberImportModal__Icon__1OFEt"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Importer/courseCodeMemberImportModal.css
// module id = 1656
// module chunks = 2